module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jouoQJ/tc-custom/9781449457365.jpg?1729082774177",
      "alt": "This image is the cover for the book Frazz 3.14, Frazz Collections"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Frazz 3.14, Frazz Collections\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Nominated by the National Cartoonist Society as Best Comic Strip, Jef Mallett's "), _c('i', [_vm._v("Frazz")]), _vm._v(" follows the life of Bryson Elementary School janitor and hit-songwriting-wonder Edwin Frazier. An all-round Renaissance man, role model, and friend rolled into one, Frazz feels as comfortable philosophizing with the students as he is with the teachers and principal.")]), _c('p', [_vm._v("Always placing an emphasis on the importance of seizing opportunities to learn and grow, "), _c('i', [_vm._v("Frazz")]), _vm._v(" is a family favorite and multiple-year recipient of the Wilbur Award from the Religion Communicators Council for excellence in communicating values and ethics.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jef Mallett\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0